import { useAuthStore } from "../store/auth";

const API_BASE = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");

type ApiOptions = {
  method?: "GET" | "POST" | "PATCH" | "DELETE";
  body?: unknown;
  signal?: AbortSignal;
};

export async function api<T = unknown>(path: string, opts: ApiOptions = {}): Promise<T> {
  const { method = "GET", body, signal } = opts;
  const accessToken = useAuthStore.getState().accessToken;
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body == null ? undefined : JSON.stringify(body),
    signal,
  });

  if (res.status === 401 && accessToken) {
    useAuthStore.getState().clear();
  }

  const json = (await res.json().catch(() => null)) as { data?: T; error?: { code: string; message: string } } | null;
  if (!res.ok) {
    const message = json?.error?.message ?? "リクエストに失敗しました";
    throw new ApiError(message, res.status, json?.error?.code);
  }
  return (json?.data ?? null) as T;
}

export class ApiError extends Error {
  constructor(message: string, public status: number, public code?: string) {
    super(message);
  }
}

export async function logout(): Promise<void> {
  try {
    await api("/api/auth/logout", { method: "POST" });
  } catch {
    // ignore
  } finally {
    useAuthStore.getState().clear();
  }
}
